import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

import Certificate from './../common/Certificate';

import { Link } from "react-router-dom";
import email from "../../assets/images/email.svg";
import facebook from "../../assets/images/facebook.svg";
import linkedin from "../../assets/images/linkedin.svg";
import logo from "../../assets/images/logo.png";
import phone from "../../assets/images/phone.svg";
import pin from "../../assets/images/pin.svg";

const useStyle = makeStyles((theme) => ({
  root: {
    marginTop: 10,
    paddingTop: 40,
    background: "#FCFCFC",
    // background: "#F0F0F0",
    [theme.breakpoints.down("sm")]: {
      marginTop: 30,
    },
  },
  icon_block: {
    display: "flex",
    alignItems: "center",
    margin: "25px 0px",
    "& img": {
      marginRight: 20,
    },
  },

  hide: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  icon_block_wrapper: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
    },
  },
  content: {
    fontSize: "1rem !important",
  },
  footer_bottom: {
    display: "flex",
    borderTop: "1px solid #EEE",
    paddingBlock: "19px",
    justifyContent: "center",
    alignItems: "center",
    "& div": {
      [theme.breakpoints.down("sm")]: {
        padding: "10px 10px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      // height: 130,

      flexDirection: "column-reverse",
      paddingBlock: "10px",
    },
  },
  menu_item: {
    color: "#666 !important",
    padding: "0px 20px !important",
    textTransform: "capitalize !important  ",
    // display: "block !important",

    "&:hover": {
      color: "#00AA61 !important",
    },
  },
  bottom_menu: {
    flex: 1,
    display: "flex",
    // justifyContent: "space-between",
    justifyContent: "flex-end",

  },
  copyright: {

    fontSize: "0.9rem !important",
    color: "#666 !important",
    [theme.breakpoints.down("sm")]: {
      // textAlign: 'left !important'
    },
  },
}));





function FooterBangla() {


  const getBanglaYear = () => {
    let res = "";
    const english_year = (new Date()).getFullYear();

  
    for( var i=0; i<english_year.toString().length; i++ ) {
      if (english_year[i] === "0") {
        res += "০";
      } else if (english_year[i] === "1") {
        res += "১";
      } else if (english_year[i] === "2") {
        res += "২";
      } else if (english_year[i] === "3") {
        res += "৩";
      } else if (english_year[i] === "4") {
        res += "৪";
      } else if (english_year[i] === "5") {
        res += "৫";
      } else if (english_year[i] === "6") {
        res += "৬";
      } else if (english_year[i] === "7") {
        res += "৭";
      } else if (english_year[i] === "8") {
        res += "৮";
      } else if (english_year[i] === "9") {
        res += "৯";
      }
    }
  
    return res;
  }
  

  const classes = useStyle();
  return (
    <>
      <Certificate></Certificate>
      <div className={classes.root}>
        <Container maxWidth="lg" id="contact">
          <Grid container spacing={3} className="pr-12">
            <Grid item md={5}>
              <img src={logo} alt="" style={{ marginBottom: 20 }} />
              <Typography variant="body2" className={classes.content} style={{textAlign: "justify", paddingRight: "10px"}}>
                এসটি পে, বাংলাদেশের প্রথম ট্রাভেল ওয়ালেট, একটি নিরাপদ ও ব্যবহারকারী-বান্ধব ক্লোজড-লুপ ডিজিটাল ওয়ালেট যা দেশের ভ্রমণ ইকোসিস্টেমসহ অন্যান্য ক্ষেত্রে পেমেন্ট সহজ করার জন্য ডিজাইন করা হয়েছে। 
                <br />
                <br />
                গ্রিন অ্যান্ড রেড টেকনোলজিস লিমিটেডের অধীনে বাংলাদেশ ব্যাংক থেকে লাইসেন্সপ্রাপ্ত এবং PCI DSS ও ISO/IEC ২৭০০১:২০২২ দ্বারা সনদপ্রাপ্ত, যা সর্বোচ্চ পেমেন্ট সিকিউরিটি ও ডেটা প্রোটেকশনের মান নিশ্চিত করে।
                <br />
                <br />
                বাংলাদেশের শীর্ষস্থানীয় ট্রাভেল প্ল্যাটফর্ম শেয়ারট্রিপ-এর সঙ্গে সংযুক্ত এসটি পে ব্যবহারকারীদের জন্য ট্রিপ বুকিং থেকে শুরু করে লাইফস্টাইল পরিষেবাগুলোর পেমেন্ট পর্যন্ত বিভিন্ন ক্ষেত্রে এক্সক্লুসিভ সুবিধা প্রদান করে।
                <br />
                <br />
                "এসটি পে – আপনার ভ্রমণ ওয়ালেট, আরও সহজভাবে।"
                <br />
                <br />
              </Typography>
            </Grid>
            <Grid item md={5}>
              <Typography variant="h6">যোগাযোগ করুন </Typography>
              <div className={classes.icon_block}>
                <img src={phone} alt="Phone" />
                <Typography variant="body2">
                  <a href="tel:8809617343434">+৮৮০ ৯৬১৭৩৪৩৪৩৪</a>
                </Typography>
              </div>
              <div className={classes.icon_block}>
                <img src={email} alt="Email" />
                <Typography variant="body2">
                  <a href="mailto:support@stpay.net">support@stpay.net</a>
                </Typography>
              </div>
              <div className={classes.icon_block}>
                <img src={pin} alt="Address" />
                <Typography variant="body2">
                  জে সি এক্স বিজনেস টাওয়ার (৮ম ফ্লোর), <br style={{ margin: "2.5px 0px" }} />
                  প্লট - ১১৩৩/এ, ব্লক - আই, , <br style={{ margin: "2.5px 0px" }} />
                  জাপান স্ট্রীট, বসুন্ধরা আর/এ, <br style={{ margin: "2.5px 0px" }} />
                  ঢাকা-১২২৯, বাংলাদেশ।
                </Typography>
              </div>
            </Grid>
            <Grid item md={2}>
              <Typography variant="h6">গেট সোশ্যাল</Typography>
              <div className={classes.icon_block_wrapper}>
                <a
                  className={classes.icon_block}
                  href="https://www.facebook.com/paywithSTPay"
                  target="_blank" rel="noreferrer"
                >
                  <img src={facebook} alt="Facebook" />
                  <Typography variant="body2" className={classes.hide}>
                    ফেইসবুক
                  </Typography>
                </a>
                {/* <a
                  className={classes.icon_block}
                  href="https://twitter.com/PaywithST Pay"
                  target="_blank" rel="noreferrer"
                >
                  <img src={twitter} alt="" />
                  <Typography variant="body2" className={classes.hide}>
                    টুইটার
                  </Typography>
                </a> */}
                <a
                  className={classes.icon_block}
                  href="https://www.linkedin.com/company/paywithstpay/"
                  target="_blank" rel="noreferrer"
                >
                  <img src={linkedin} alt="লিঙ্কডইন" />
                  <Typography variant="body2" className={classes.hide}>
                    লিঙ্কডইন{" "}
                  </Typography>
                </a>
                {/* <a
                  className={classes.icon_block}
                  href="https://www.instagram.com/sharetripapp/?hl=en"
                  target="_blank" rel="noreferrer"
                >
                  <img src={instagram} alt="" />
                  <Typography variant="body2" className={classes.hide}>
                    ইন্সটাগ্রাম
                  </Typography>
                </a> */}
                {/* <div className={classes.icon_block}>
                  <img src={youtube} alt="" />
                  <Typography variant="body2" className={classes.hide}>
                    Youtube
                  </Typography>
                </div> */}
              </div>
            </Grid>
          </Grid>
          <div
            className={classes.footer_bottom}
          // justifyContent="center"
          // alignContent="center"
          >
            <div>
              <Typography variant="body1" className={classes.copyright}>
                &copy; কপিরাইট {(new Date()).getFullYear()}। এসটি পে একটি
                <strong> গ্রীন এন্ড রেড টেকনোলজিস লিমিটেড</strong> প্রতিষ্ঠান, সর্বস্বত্ব সংরক্ষিত।
              </Typography>
            </div>
            <div className={classes.bottom_menu}>
              <Button variant="text" className={classes.menu_item}>
                <Link to="/privacy-policy">
                  <Typography variant="subtitle1">গোপনীয়তা নীতি</Typography>
                </Link>
              </Button>
              <Button variant="text" className={classes.menu_item}>
                <Link to="/terms-condition">
                  <Typography variant="subtitle1">নিয়ম ও শর্তাবলী</Typography>
                </Link>
              </Button>
              <Button variant="text" className={classes.menu_item}>
                <Link to="/faq">
                  <Typography variant="subtitle1">সাধারণ জিজ্ঞাসা</Typography>
                </Link>
              </Button>

            </div>
          </div>
        </Container>
      </div>  
    </>
  );
}


export default FooterBangla;
